import React from "react";
import "../../App.css";
import "./About.css";
import me from "../../../src/images/rectangel.jpg";
import MailIcon from "../../../src/images/icons/mail-icon.svg";
import LinkedinIcon from "../../../src/images/icons/linkedin-icon.svg";

export default function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="about-header">
          <div className="about-text">
            <h1 className="title">Hi!</h1>
            <p className="text">
              I recently graduated from Chalmers University of Technology with a
              master's degree in Interaction Design and Technologies. My
              background is in Design and Product Development, but during my
              master's, I shifted my focus toward frontend development and UX/UI
              design. I am passionate about building interactive, user-friendly
              web applications and enjoy the challenge of blending aesthetics
              with functionality. My goal is to create visually appealing,
              intuitive, and accessible digital experiences. I'm always eager to
              learn, explore new technologies, and refine my skills to develop
              meaningful and impactful products.
            </p>
          </div>
          <div className="about-image">
            <img src={me} alt="me" />
          </div>
        </div>

        <div className="about-section">
          <h1 className="title">Education</h1>
          <div className="about-education">
            <p className="text">
              Bachelor's degree: Chalmers University of Technology - Design and
              Product Development
            </p>
            <p className="text">
              Master's degree: Chalmers University of Technology - Interaction
              Design and Technologies
            </p>
          </div>
        </div>

        <div className="about-section">
          <h1 className="title">Contact</h1>
          <div className="about-contact">
            <p className="text">
              I'm always open to new opportunities and connections. Don't
              hesitate to contact me via LinkedIn or email!
            </p>

            <div className="about-links">
              <div className="about-link-item">
                <img src={LinkedinIcon} alt="LinkedIn" />
                <a
                  href="https://www.linkedin.com/in/linnea-matilda-olsson"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedin.com/in/linnea-matilda-olsson
                </a>
              </div>
              <div className="about-link-item">
                <img src={MailIcon} alt="Mail" />
                <a
                  href="mailto:linnea.matilda99@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linnea.matilda99@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="about-section">
          <h1 className="title">Development & Technology</h1>
          <div className="about-contact">
            <p className="text">
              This website was designed in Figma, developed with React, and
              hosted on Netlify with continuous deployment via GitHub.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
